import { render, staticRenderFns } from "./header_culinary.vue?vue&type=template&id=04d073c9&"
import script from "./header_culinary.vue?vue&type=script&lang=js&"
export * from "./header_culinary.vue?vue&type=script&lang=js&"
import style0 from "./header_culinary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports